import React from 'react'
import { Box, Typography } from '@mui/material'
import { Footer } from 'components/OrderFormR'

export const NotReady: React.FC = () => {
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'center', m: '5em' }}>
        <Typography variant="h6">
          現在準備中です。
          <br />
          サービスのお申し込みは2月以降を予定しております。
          <br />
          恐れ入りますが、今しばらくお待ちください。
        </Typography>
      </Box>
      <Footer />
    </>
  )
}
